export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11315.7aed7de1.jpg";